<div class="circle-number-substep">
    <span [ngClass]="isSubstep ? 'substep' : ''">{{stepNumber}}</span>
</div>
